var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star",style:(_vm.sizeStyle)},[_c('svg-icon',{staticClass:"star__icon",attrs:{"name":_vm.fillName,"width":_vm.size.toString(),"height":_vm.size.toString()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }